module.exports = __webpack_public_path__ + "img/base_restauration_vin.197aed0f.svg";